module.exports = __webpack_public_path__ + "static/media/c++.4fce8d00.png";